import { adminHttpClient } from '../../../commons/adminHttpClient'
import AllowanceType from '../../../../domain/benefit/allowanceType'

export interface AllowanceTypeValues {
  allowanceType: AllowanceType | null
  planPeriodId?: string
}

const AllowanceTypeAPI = (allowanceTypeValues: AllowanceTypeValues) => {
  return adminHttpClient.put('/AdminDashboard/BenefitDesign/AllowanceType', allowanceTypeValues)
}

export default AllowanceTypeAPI
